export class ContratanteDireccion {
    public idx: number = 0;
    public direccionClienteID: string = "";
    public fiscal: number = 1;
    public nombre: string = "";
    public apellidoPaterno: string = "";
    public apellidoMaterno: string = "";
    public calle: string = "";
    public numeroExterno: string = "";
    public numeroInterno: string = "";
    public colonia: string = "";
    public municipio: string = "";
    public estado: string = "";
    public codigoPostal: string = "";
    public fechaNacimiento: string = "";
    public rfc: string = "";
    public sexo: boolean = true;
    public codigoPostalID: number = 0;
    public telefono: string = "";
    public principal: boolean = true;
    public seleccionada: boolean = true;
    public personaDireccionID: number = 0;
    public personaID: number = 0;
    public noEdit: boolean = false;
    public blocked: boolean = false;
}